import { render } from "./opportunity-create-congrats.vue?vue&type=template&id=19ed1961&ts=true"
import script from "./opportunity-create-congrats.vue?vue&type=script&lang=ts"
export * from "./opportunity-create-congrats.vue?vue&type=script&lang=ts"

import "./opportunity-create-congrats.vue?vue&type=style&index=0&id=19ed1961&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__